import React from "react";

export function Table({ data = [] }) {
  const dataSet = data.filter(({ location }) => location === 'Empresa Grupo Técnico Basse Ltda');
  const elements = [
    { parameter: 'Estadísticas NOx', detail: 'Óxidos de Nitrógeno', interval: '20 min', count: dataSet.length, badge: 'NOx' },
    { parameter: 'Estadísticas CO', detail: 'Monóxido de Carbono', interval: '20 min', count: dataSet.length, badge: 'CO' },
  ];

  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-card overflow-hidden h-full flex flex-col justify-between">
      <div className="px-5 py-3.5 bg-slate-50/80 border-b border-slate-100 flex items-center justify-between">
        <div className="text-xs font-bold uppercase tracking-wider text-slate-500">
          Monitoreo de Variables
        </div>
        <span className="text-[11px] font-semibold text-primary bg-primary-light px-2.5 py-0.5 rounded-full">
          Estación Activa
        </span>
      </div>

      <div className="p-4 divide-y divide-slate-100 flex-1 flex flex-col justify-around">
        {elements.map(({ parameter, detail, interval, count, badge }, i) => (
          <div key={i} className="flex items-center justify-between py-2.5 px-2 hover:bg-slate-50/60 rounded-xl transition-colors">
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 rounded-lg bg-primary-light text-primary font-extrabold text-xs flex items-center justify-center">
                {badge}
              </span>
              <div>
                <p className="text-sm font-bold text-slate-800">{parameter}</p>
                <p className="text-[11px] text-slate-400">{detail}</p>
              </div>
            </div>
            <div className="flex items-center gap-6">
              <div className="text-right">
                <span className="text-xs font-medium text-slate-400 block">Frecuencia</span>
                <span className="text-xs font-bold text-slate-700">{interval}</span>
              </div>
              <div className="text-right min-w-[70px]">
                <span className="text-xs font-medium text-slate-400 block">Muestras</span>
                <span className="text-sm font-extrabold text-slate-900 bg-slate-100 px-2.5 py-0.5 rounded-md">
                  {count}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}